import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../api';

export default function ArticleView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const query = new URLSearchParams(location.search);
        const urlParam = query.get('url');
        if (!urlParam) throw new Error("No URL provided");
        
        const res = await api.get(`/article?url=${encodeURIComponent(urlParam)}`);
        setArticle(res.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError('Failed to load article. Please ensure axios and cheerio are installed in the backend.');
        setLoading(false);
      }
    };
    fetchArticle();
  }, []);

  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#f3f4f6',
      padding: '20px',
      fontFamily: "'Inter', sans-serif"
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '30px',
      backgroundColor: 'white',
      padding: '15px 20px',
      borderRadius: '12px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    },
    backBtn: {
      background: 'none',
      border: 'none',
      fontSize: '24px',
      cursor: 'pointer',
      marginRight: '15px',
      color: '#4b5563'
    },
    title: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#1f2937',
      margin: 0
    },
    contentCard: {
      backgroundColor: 'white',
      padding: '40px',
      borderRadius: '16px',
      boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
      maxWidth: '800px',
      margin: '0 auto'
    },
    articleTitle: {
      fontFamily: '"Noto Serif Malayalam", "Noto Serif Malayalam Fallback", serif',
      fontSize: '30px',
      fontWeight: '600',
      color: '#111827', /* Kept dark color because background is white. If you need white text, the background must be changed to black */
      marginBottom: '30px',
      lineHeight: '1.4',
      textAlign: 'start'
    },
    paragraph: {
      fontFamily: '"Noto Serif Malayalam", "Noto Serif Malayalam Fallback", serif',
      fontSize: '16px',
      fontWeight: '400',
      color: '#2A2A2A',
      lineHeight: '1.5',
      marginBottom: '20px',
      textAlign: 'start' // start aligns left for English/Malayalam, right for Arabic
    }
  };

  return (
    <div style={styles.container}>
      <style>
        {`@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+Malayalam:wght@400;600&display=swap');`}
      </style>
      <div style={styles.header}>
        <button onClick={() => {
          const isTest = new URLSearchParams(location.search).get('testChannel') === 'true';
          navigate(isTest ? '/student-react/test-channel' : '/student-react/dashboard');
        }} style={styles.backBtn}>←</button>
        <h2 style={styles.title}>Article Reading</h2>
      </div>

      <div style={styles.contentCard}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', fontSize: '18px', color: '#6b7280' }}>
            Loading article...
          </div>
        ) : error ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#ef4444' }}>
            {error}
          </div>
        ) : (
          <>
            <h1 style={styles.articleTitle} dir="auto">{article?.title}</h1>
            {article?.paragraphs?.map((p, idx) => (
              <p key={idx} dir="auto" style={styles.paragraph}>{p}</p>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
